import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import { getPackagesAttributes } from './utils';

import type {
  ConductorCreativeFlightsPackagesFields,
  CreativeFlightsPackages,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getPackagesCreative = (
  fields: ConductorCreativeFlightsPackagesFields,
): CreativeFlightsPackages => {
  const {
    appIndex,
    brandedWrapperColour,
    ctaCopy = null,
    customDestination = null,
    customPackageAttribute1,
    customPackageAttribute2,
    customPackageAttribute3,
    customPackageAttribute4,
    destination,
    headline = null,
    heroImage,
    packageAttributes,
    partnerLogo,
    partnerName,
    pioAgencyName,
    pioPartnerName,
    redirectUrl,
    showTermsAndConditions,
    splitTestId,
    sponsoredTargetDestination,
    sponsoredText,
    strevdaId,
    valueProposition,
    wrapperTextColour,
  } = fields;

  const customAttributes = [
    customPackageAttribute1,
    customPackageAttribute2,
    customPackageAttribute3,
    customPackageAttribute4,
  ];

  return {
    appIndex,
    ctaCopy,
    headline,
    heroImage,
    destination,
    customDestination,
    partnerLogo,
    partnerName,
    redirectUrl,
    strevdaId,
    valueProposition,
    sponsoredTargetDestination,
    sponsoredText,
    brandedWrapperColour,
    packageAttributes: getPackagesAttributes(packageAttributes, customAttributes),
    wrapperTextColour,
    showTermsAndConditions: showTermsAndConditions === 'true',
    format: ADVERT_FORMAT_TYPES.PACKAGES_INLINE,
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
